export default {
  "女模": "Nữ người mẫu",
  "男模": "Nam người mẫu",
  "加载中": "Đang tải",
  "已有账号？": "Đã có tài khoản?",
  "去登录": "Đăng nhập",
  "首次登录，请选择语言": "Đăng nhập lần đầu, vui lòng chọn ngôn ngữ",
  "立即切换": "Đổi ngay",
  "投注": "Đặt cược",
  "请先绑定银行卡": "Vui lòng liên kết thẻ ngân hàng trước",
  "历史": "Lịch sử",
  "绑定上限，请联系客服!": "Đã đạt giới hạn liên kết, vui lòng liên hệ bộ phận chăm sóc khách hàng!",
  "已达绑定上限": "Đã đạt giới hạn liên kết",
  "任务详情": "Chi tiết nhiệm vụ",
  "投票详情": "Chi tiết bỏ phiếu",
  "获得金额": "Số tiền nhận được",
  "待结算": "Chờ thanh toán",
  "再来一次": "Thử lại lần nữa",
  "时间": "Thời gian",
  "备注": "Ghi chú",
  "服务评分": "Đánh giá dịch vụ",

  accountDetailTab: {
    "充值": 'Nạp tiền',
    "提现": 'Rút tiền',
    "投票": 'Chi tiết bỏ phiếu',
  },
  "选择{name}": "Chọn {name}",
  "个人简介": "Thông tin cá nhân",
  "投票金额": "Số tiền bỏ phiếu",
  "投票记录": "Hồ sơ bỏ phiếu",
  "投票方向": "Hướng bỏ phiếu",
  "下注金额": "Số tiền đặt cược",
  "我已经知晓并同意'开户协议'各项条约": "Tôi đã biết và đồng ý với các điều khoản của 'Điều khoản mở tài khoản'",
  "投票": "Bỏ phiếu",
  "确认投票": "Xác nhận bỏ phiếu",
  "银行账户号码": "Số tài khoản ngân hàng",
  "提现到": "Rút tiền về",
  "去绑定": "Đi liên kết",
  "信誉分": "Điểm uy tín",
  "取款方式": "Phương thức rút tiền",
  "立即预约": "Đặt lịch ngay",
  "住所": "Địa chỉ cư trú",
  "照片": "Ảnh",
  "胸围": "Vòng ngực",
  "约炮推荐": "Gợi ý hẹn hò",
  "高端专区": "Khu vực cao cấp",
  "暂无信息": "Không có thông tin",
  "观影券": "Phiếu xem phim",
  "观影券不足": "Không đủ phiếu xem phim",
  "详情信息": "Thông tin chi tiết",
  "银行卡": "Thẻ ngân hàng",
  "x次认证": "{num} lần xác minh",
  "请输入您的收款卡信": "Vui lòng nhập thông tin thẻ nhận tiền của bạn",
  "绑定银行卡": "Liên kết thẻ ngân hàng",
  "绑定USDT地址": "Liên kết địa chỉ USDT",
  "请选择{name}": "Vui lòng chọn {name}",
  "请输入{name}": "Vui lòng nhập {name}",
  "银行地址": "Địa chỉ ngân hàng",
  "银行账户": "Tài khoản ngân hàng",
  "ABA/路由代码": "Mã ABA / định tuyến",
  "SWIFT代码": "Mã SWIFT",
  "姓名": "Họ và tên",
  "虚拟币": "Tiền mã hóa",
  "币种": "Loại tiền tệ",
  "地址": "Địa chỉ",
  "确认绑定": "Xác nhận liên kết",
  "银行列表": "Danh sách ngân hàng",
  "暂无数据": "Không có dữ liệu",
  '充值': 'Nạp tiền',
  '旧密码': 'Mật khẩu cũ',
  '新密码': 'Mật khẩu mới',
  '请输入您的旧密码': 'Vui lòng nhập mật khẩu cũ của bạn',
  '请输入您的新密码': 'Vui lòng nhập mật khẩu mới của bạn',
  '请再次输入您的新密码': 'Vui lòng nhập lại mật khẩu mới của bạn',
  '修改登录密码': 'Thay đổi mật khẩu đăng nhập',
  '收款卡信息': 'Thông tin thẻ nhận tiền',
  '投票结果': 'Kết quả bỏ phiếu',
  tabbar: {
      '首页': 'Trang chủ',
      '预约': 'Đặt lịch',
      '地区选择': 'Chọn khu vực',
      '视频': 'Video',
      '我的': 'Tôi'
  },
  "高端": "Cao cấp",
  '认证': 'Xác minh',
  '视频认证': 'Xác minh video',
  '收费区间': 'Khoảng phí',
  '身高': 'Chiều cao',
  '胸圍': 'Vòng ngực',
  '服務城市': 'Thành phố phục vụ',
  '全國空降': 'Nhảy dù toàn quốc',
  '是': 'Có',
  '否': 'Không',
  '我要约她': 'Tôi muốn hẹn cô ấy',
  '我要约他': 'Tôi muốn hẹn anh ấy',
  '城市大全': 'Toàn bộ thành phố',
  '流程价格': 'Giá quy trình',
  '刷新成功': 'Làm mới thành công',
  '预约大厅': 'Hội trường đặt lịch',
  '全部': 'Tất cả',
  '查看更多': 'Xem thêm',
  '推荐任务': 'Nhiệm vụ được đề xuất',
  '人气排行': 'Xếp hạng phổ biến',
  '热门推荐': 'Đề xuất nổi bật',
  '获取中': 'Đang lấy',
  '语言': 'Ngôn ngữ',
  '登录': 'Đăng nhập',
  '忘记密码': 'Quên mật khẩu',
  '没有账户？马上注册': 'Không có tài khoản? Đăng ký ngay',
  '请输入用户名': 'Vui lòng nhập tên người dùng',
  '请输入密码': 'Vui lòng nhập mật khẩu',
  '注册': 'Đăng ký',
  '我已经知晓并同意"开户协议"各项条约': 'Tôi đã biết và đồng ý với các điều khoản của "Điều khoản mở tài khoản"',
  '请输入邀请码': 'Vui lòng nhập mã mời',
  '请输入用户名({min}-{max}个英文字母或数字)': 'Vui lòng nhập tên người dùng ({min}-{max} chữ cái tiếng Anh hoặc số)',
  '请输入登录密码({min}-{max}个英文字母或数字)': 'Vui lòng nhập mật khẩu đăng nhập ({min}-{max} chữ cái tiếng Anh hoặc số)',
  '请勾选下方开户协议': 'Vui lòng đánh dấu vào điều khoản mở tài khoản bên dưới',
  '可用余额': 'Số dư khả dụng',
  '元': 'Yuan',
  '提交': 'Gửi',
  '当前选号': 'Số hiện tại được chọn',
  '每注金额': 'Số tiền mỗi lần đặt cược',
  '请输入金额': 'Vui lòng nhập số tiền',
  '总共': 'Tổng cộng',
  '注': 'Lần đặt cược',
  '合计': 'Tổng cộng',
  '任务单': 'Phiếu nhiệm vụ',
  '1注X{money}元={money}元': '1 lần đặt cược X {money} = {money}',
  '清空订单': 'Xóa đơn hàng',
  '确认提交': 'Xác nhận gửi',
  '期号': 'Số kỳ',
  '第{x}期': 'Kỳ thứ {x}',
  '数据': 'Dữ liệu',
  '双': 'Chẵn',
  '单': 'Lẻ',
  '未选择': 'Chưa chọn',
  '金额错误': 'Số tiền không chính xác',
  '请选号': 'Vui lòng chọn số',
  '请填写金额': 'Vui lòng điền số tiền',
  '余额不足，请联系客服充值！': 'Số dư không đủ, vui lòng liên hệ bộ phận chăm sóc khách hàng để nạp tiền!',
  '未选中': 'Chưa được chọn',
  '请联系管理员领取该任务': 'Vui lòng liên hệ quản trị viên để nhận nhiệm vụ này',
  '开奖成功，期号：': 'Mở thưởng thành công, số kỳ:',
  '大': 'Lớn',
  '小': 'Nhỏ',
  '填写收款卡': 'Điền thông tin thẻ nhận tiền',
  '请输入您的收款卡信息': 'Vui lòng nhập thông tin thẻ nhận tiền của bạn',
  '银行卡号': 'Số thẻ ngân hàng',
  '请输入真实银行卡号': 'Vui lòng nhập số thẻ ngân hàng thật',
  '银行名称': 'Tên ngân hàng',
  '请选择银行': 'Vui lòng chọn ngân hàng',
  '尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款': 'Kính gửi người dùng, để đảm bảo an toàn tài khoản của bạn, vui lòng liên kết tên thật và thiết lập mật khẩu rút tiền. Nếu tên không khớp với tên mở tài khoản, bạn sẽ không thể rút tiền.',
  '确认绑卡': 'Xác nhận liên kết thẻ',
  '请输入银行卡号': 'Vui lòng nhập số thẻ ngân hàng',
  '任务记录': 'Hồ sơ nhiệm vụ',
  '任务记录Title': 'Hồ sơ nhiệm vụ',
  '数据为空': 'Dữ liệu trống',
  '下单时间': 'Thời gian đặt hàng',
  '结算时间': 'Thời gian thanh toán',
  '提现': 'Rút tiền',
  '我的钱包': 'Ví của tôi',
  '详情': 'Chi tiết',
  '余额': 'Số dư',
  '个人报表': 'Báo cáo cá nhân',
  '账户明细': 'Chi tiết tài khoản',
  '个人中心': 'Trung tâm cá nhân',
  '信息公告': 'Thông báo thông tin',
  '在线客服': 'Hỗ trợ trực tuyến',
  '请完成任务单后进入': 'Vui lòng hoàn thành phiếu nhiệm vụ trước khi vào',
  '请联系客服充值': 'Vui lòng liên hệ bộ phận chăm sóc khách hàng để nạp tiền',
  '请设置收款卡': 'Vui lòng thiết lập thẻ nhận tiền',
  '功能已禁用': 'Chức năng đã bị vô hiệu hóa',
  '账号下线': 'Tài khoản đã ngừng hoạt động',
  '登录/注册': 'Đăng nhập/Đăng ký',
  '登录可享受更多服务': 'Đăng nhập để tận hưởng nhiều dịch vụ hơn',
  '基本信息': 'Thông tin cơ bản',
  '头像': 'Ảnh đại diện',
  '选择头像': 'Chọn ảnh đại diện',
  '确定': 'Xác nhận',
  '取消': 'Hủy',
  '真实姓名': 'Họ và tên thật',
  '未设置': 'Chưa thiết lập',
  '性别': 'Giới tính',
  '绑定信息': 'Thông tin liên kết',
  '已绑定': 'Đã liên kết',
  '无': 'Không',
  '男': 'Nam',
  '女': 'Nữ',
  '未知': 'Không xác định',
  '系统公告': 'Thông báo hệ thống',
  '盈利金额': 'Số tiền lợi nhuận',
  '盈利计算公式 : 中奖金额 - 任务金额': 'Công thức tính lợi nhuận: Số tiền trúng thưởng - Số tiền nhiệm vụ',
  '任务金额': 'Số tiền nhiệm vụ',
  '充值金额': 'Số tiền nạp',
  '提现金额': 'Số tiền rút',
  '中奖金额': 'Số tiền trúng thưởng',
  '客服': 'Hỗ trợ khách hàng',
  '蜜獾娱乐': 'Giải trí Honey Badger',
  '联系': 'Liên hệ',
  '全天7 * 24小时竭诚为您服务': 'Phục vụ bạn tận tâm 24/7',
  '添加收款卡': 'Thêm thẻ nhận tiền',
  '提示:请绑定大型商业银行,如需修改,请您联系在线客服': 'Lưu ý: Vui lòng liên kết với các ngân hàng thương mại lớn. Nếu cần thay đổi, vui lòng liên hệ bộ phận chăm sóc khách hàng trực tuyến',
  '修改真实姓名': 'Thay đổi họ và tên thật',
  '保存': 'Lưu',
  '请输入真实姓名': 'Vui lòng nhập họ và tên thật',
  '为了您账户安全,真实姓名需要与绑定银行卡姓名一致': 'Để đảm bảo an toàn tài khoản của bạn, họ và tên thật cần khớp với tên trên thẻ ngân hàng đã liên kết',
  '请勿重复设置': 'Vui lòng không thiết lập lại',
  '请输入姓名': 'Vui lòng nhập tên',
  '请输入资金密码': 'Vui lòng nhập mật khẩu tài chính',
  '设置资金密码': 'Thiết lập mật khẩu tài chính',
  '请再次输入资金密码': 'Vui lòng nhập lại mật khẩu tài chính',
  '请填写完整': 'Vui lòng điền đầy đủ',
  '两次密码不一致': 'Hai mật khẩu không khớp',
  '性别修改': 'Thay đổi giới tính',
  '设置': 'Thiết lập',
  '基本信息设置': 'Thiết lập thông tin cơ bản',
  '登录密码': 'Mật khẩu đăng nhập',
  '资金密码': 'Mật khẩu tài chính',
  '退出登录': 'Đăng xuất',
  '已设置': 'Đã thiết lập',
  '提现密码已设置，需要修改请联系客服': 'Mật khẩu rút tiền đã được thiết lập, nếu cần thay đổi vui lòng liên hệ bộ phận chăm sóc khách hàng',
  '提现中心': 'Trung tâm rút tiền',
  '提现记录': 'Hồ sơ rút tiền',
  '1.单笔限额：最低{min}元，最高{max}元': '1. Hạn mức đơn hàng: Tối thiểu {min} Yuan, tối đa {max} Yuan',
  '2.提现次数：一天最高提现{num}次': '2. Số lần rút tiền: Tối đa {num} lần mỗi ngày',
  '3.到账时间': '3. Thời gian đến tài khoản: Khoảng 15 phút, tối đa trong vòng 2 giờ',
  '限额说明': 'Giải thích hạn mức',
  '马上提现': 'Rút tiền ngay',
  '请填写正确的金额': 'Vui lòng nhập số tiền chính xác',
  '金额': 'Số tiền',
  '说明': 'Giải thích',
  '提交时间': 'Thời gian gửi',
  '审核时间': 'Thời gian xem xét',
  '视频影院': 'Rạp chiếu phim video',
  '没有更多了': 'Không còn nữa',
  '播放': 'Phát',
  'x播放': '{count} lượt phát',
  '首页': 'Trang chủ',
  '选妃': 'Chọn phi tần',
  '选妃列表': 'Danh sách chọn phi tần',
  '选妃详情': 'Chi tiết chọn phi tần',
  '语言选择': 'Chọn ngôn ngữ',
  '我的': 'Tôi',
  '视频': 'Video',
  '游戏': 'Trò chơi',
  '修改性别': 'Thay đổi giới tính',
  '支付密码管理': 'Quản lý mật khẩu thanh toán',
  "登录密码管理": "Quản lý mật khẩu đăng nhập",
  "详情页面": "Trang chi tiết",
  "视频播放": "Phát video",

  "本期":"Kỳ hiện tại",
  "剩余时间":"Thời gian còn lại",
  "立即投票":"Bỏ phiếu ngay",
  "提前预订卡进度":"Tiến độ thẻ đặt trước",

  "预订状态":"Trạng thái đặt trước",
}